import { isBackendProd } from "../../clientRestAPI/clientRestAPI";
 
const ConsoleLog = (...args) => {
     if(isBackendProd() === 'H') {
        console.log(...args);
    }
};

export default ConsoleLog;
